module.exports = __webpack_public_path__ + "img/sk-partners-HN.1a196b13.png";